import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_WITH_STATE_TRANSITIONS_REMOVED_OR_UPDATED = gql`
  subscription documentTypeWithStateTransitionsRemovedOrUpdated {
    documentTypeWithStateTransitionsRemovedOrUpdated {
      documentTypeId
    }
  }
`;

export const DOCUMENT_STATE_TRANSITION_RIGHTS_IMPORTED = gql`
  subscription documentStateTransitionRightsImported {
    documentStateTransitionRightsImported
  }
`;
